import { render, staticRenderFns } from "./ProcessDetails.vue?vue&type=template&id=ce2f9e78&scoped=true&"
import script from "./ProcessDetails.vue?vue&type=script&lang=js&"
export * from "./ProcessDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetails.vue?vue&type=style&index=0&id=ce2f9e78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f9e78",
  null
  
)

export default component.exports